const ROOT = '[data-drv-pill-marquee]';
const TRACK = '[data-drv-pill-marquee-track]';
const MAX_REPEATS = 40;

const built = new WeakSet();
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const onScreen = new IntersectionObserver((entries) => {
  for (const entry of entries) entry.target.classList.toggle('is-onscreen', entry.isIntersecting);
});

function copy(node) {
  const clone = node.cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  return clone;
}

function build(root) {
  const track = root.querySelector(TRACK);
  if (!track) return;

  const visible = root.clientWidth;
  if (!visible) return;

  if (!track.dataset.drvSeed) track.dataset.drvSeed = track.innerHTML;
  track.innerHTML = track.dataset.drvSeed;

  const seed = [...track.children];
  if (!seed.length) return;

  let cycle = track.scrollWidth;
  if (!cycle) return;

  let guard = 0;
  while (cycle < visible && guard < MAX_REPEATS) {
    for (const node of seed) track.appendChild(copy(node));
    cycle = track.scrollWidth;
    guard += 1;
  }

  const unit = [...track.children];
  for (const node of unit) track.appendChild(copy(node));

  const speed = Number(root.dataset.speed) || 40;
  track.style.setProperty('--drv-mq-cycle', `${cycle}px`);
  track.style.setProperty('--drv-mq-duration', `${Math.max(cycle / speed, 1)}s`);
  root.classList.add('is-running');
  built.add(root);
}

function watch(root) {
  if (reduceMotion.matches || root.hasAttribute('data-static')) return;

  const ro = new ResizeObserver(() => {
    if (!root.isConnected) {
      ro.disconnect();
      onScreen.unobserve(root);
      return;
    }
    if (!root.clientWidth) return;
    if (built.has(root)) return;
    build(root);
  });
  ro.observe(root);
  onScreen.observe(root);

  for (const img of root.querySelectorAll('img')) {
    if (img.complete) continue;
    img.addEventListener(
      'load',
      () => {
        built.delete(root);
        build(root);
      },
      { once: true }
    );
  }
}

function scan() {
  for (const root of document.querySelectorAll(ROOT)) {
    if (built.has(root) || root.dataset.drvWatched) continue;
    root.dataset.drvWatched = 'true';
    watch(root);
  }
}

scan();

new MutationObserver(scan).observe(document.documentElement, {
  childList: true,
  subtree: true,
});

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (reduceMotion.matches) return;
    for (const root of document.querySelectorAll(ROOT)) {
      if (root.hasAttribute('data-static')) continue;
      built.delete(root);
      root.classList.remove('is-running');
      build(root);
    }
  }, 200);
});
